'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = function (schema, data) {
  return Object.keys(schema).filter(function (key) {
    return (0, _lodash4.default)(schema[key].applicable) ? schema[key].applicable(data) : true;
  }).reduce(function (output, key) {
    var _normalizeSchema = normalizeSchema(schema[key]),
        whitelist = _normalizeSchema.whitelist,
        value = _normalizeSchema.value;

    if ((0, _lodash4.default)(value)) {
      return setIfDefined(output, key, value(data));
    }

    if ((0, _lodash6.default)(value)) {
      if (whitelist) {
        return setIfDefined(output, key, (0, _lodash2.default)(whitelist, (0, _lodash2.default)(data, value)));
      }

      return setIfDefined(output, key, (0, _lodash2.default)(data, value));
    }

    return output;
  }, {});
};

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.isfunction');

var _lodash4 = _interopRequireDefault(_lodash3);

var _lodash5 = require('lodash.isstring');

var _lodash6 = _interopRequireDefault(_lodash5);

var _lodash7 = require('lodash.set');

var _lodash8 = _interopRequireDefault(_lodash7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var normalizeSchema = function normalizeSchema(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? value : { value: value };
};

function setIfDefined(target, key, value) {
  if (value !== undefined) {
    (0, _lodash8.default)(target, key, value);
  }

  return target;
}